import { useEffect, useContext, useRef } from 'react'
import { WebGLRenderer } from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'

import { ModelControls } from '../utils/ModelControls'
import { useAppStore, StoreContext } from '../../shared/store/store'

export function useAutoRotate(
  renderer: WebGLRenderer | undefined,
  controls: ModelControls | OrbitControls | undefined,
) {
  const store = useContext(StoreContext)
  const timeoutRef = useRef<number>(0)
  const autoRotateSpeed = useAppStore((state) => state.autoRotateSpeed)

  function stopAutoRotate() {
    if (controls) {
      controls.autoRotate = false
    }
  }

  function resumeAutoRotate() {
    if (timeoutRef.current > 0) {
      clearTimeout(timeoutRef.current)
      timeoutRef.current = 0
    }

    timeoutRef.current = setTimeout(() => {
      if (controls && store?.getState() !== undefined) {
        controls.autoRotate = true
      }
    }, 1000)
  }

  useEffect(() => {
    if (!renderer || !controls) {
      return
    }

    const domElement = renderer.domElement

    const eventStart = 'pointerdown'

    const eventEnd = 'pointerup'
    if (autoRotateSpeed !== undefined) {
      domElement.addEventListener(eventStart, stopAutoRotate)
      domElement.addEventListener(eventEnd, resumeAutoRotate)
    }

    return () => {
      domElement.removeEventListener(eventStart, stopAutoRotate)
      domElement.removeEventListener(eventEnd, resumeAutoRotate)
      clearTimeout(timeoutRef.current)
    }
  }, [renderer, controls])
}
